import {
  LandRecord,
  Notification,
  User,
  DeedType,
  LandType,
  District,
  CourtName,
  SubRegistryOffice,
  Document,
} from './types'

// Helper to generate IDs
const generateId = () => Math.random().toString(36).substr(2, 9)

// Master Data
export const deedTypes: DeedType[] = [
  { id: '1', name: 'Sale Deed', nameBn: 'বিক্রয় দলিল', status: 'Active' },
  { id: '2', name: 'Gift Deed', nameBn: 'হেবা দলিল', status: 'Active' },
  { id: '3', name: 'Exchange Deed', nameBn: 'বিনিময় দলিল', status: 'Active' },
  { id: '4', name: 'Partition Deed', nameBn: 'বন্টন দলিল', status: 'Active' },
  { id: '5', name: 'Mortgage Deed', nameBn: 'বন্ধকী দলিল', status: 'Active' },
  { id: '6', name: 'Lease Deed', nameBn: 'ইজারা দলিল', status: 'Active' },
  {
    id: '7',
    name: 'Power of Attorney',
    nameBn: 'পাওয়ার অব অ্যাটর্নি',
    status: 'Active',
  },
  { id: '8', name: 'Will Deed', nameBn: 'উইল দলিল', status: 'Active' },
]

export const landTypes: LandType[] = [
  { id: '1', name: 'Industrial', nameBn: 'শিল্প', status: 'Active' },
  { id: '2', name: 'Commercial', nameBn: 'বাণিজ্যিক', status: 'Active' },
  { id: '3', name: 'Agricultural', nameBn: 'কৃষি', status: 'Active' },
  { id: '4', name: 'Residential', nameBn: 'আবাসিক', status: 'Active' },
  { id: '5', name: 'Mixed Use', nameBn: 'মিশ্র ব্যবহার', status: 'Active' },
  { id: '6', name: 'Warehouse', nameBn: 'গুদাম', status: 'Active' },
]

export const districts: District[] = [
  { id: '1', name: 'Dhaka', nameBn: 'ঢাকা', status: 'Active' },
  { id: '2', name: 'Gazipur', nameBn: 'গাজীপুর', status: 'Active' },
  { id: '3', name: 'Narayanganj', nameBn: 'নারায়ণগঞ্জ', status: 'Active' },
  { id: '4', name: 'Chittagong', nameBn: 'চট্টগ্রাম', status: 'Active' },
  { id: '5', name: 'Rajshahi', nameBn: 'রাজশাহী', status: 'Active' },
  { id: '6', name: 'Sylhet', nameBn: 'সিলেট', status: 'Active' },
  { id: '7', name: 'Comilla', nameBn: 'কুমিল্লা', status: 'Active' },
  { id: '8', name: 'Rangpur', nameBn: 'রংপুর', status: 'Active' },
  { id: '9', name: 'Khulna', nameBn: 'খুলনা', status: 'Active' },
  { id: '10', name: 'Mymensingh', nameBn: 'ময়মনসিংহ', status: 'Active' },
  { id: '11', name: 'Bogra', nameBn: 'বগুড়া', status: 'Active' },
  { id: '12', name: 'Jessore', nameBn: 'যশোর', status: 'Active' },
]

export const courtNames: CourtName[] = [
  { id: '1', name: 'District Judge Court, Dhaka', status: 'Active' },
  { id: '2', name: 'District Judge Court, Gazipur', status: 'Active' },
  { id: '3', name: 'District Judge Court, Narayanganj', status: 'Active' },
  { id: '4', name: 'High Court Division, Dhaka', status: 'Active' },
  { id: '5', name: 'Civil Court, Dhamrai', status: 'Active' },
  { id: '6', name: 'District Judge Court, Chittagong', status: 'Active' },
]

export const subRegistryOffices: SubRegistryOffice[] = [
  {
    id: '1',
    name: 'Dhamrai Sub-Registry Office',
    districtId: '1',
    status: 'Active',
  },
  {
    id: '2',
    name: 'Savar Sub-Registry Office',
    districtId: '1',
    status: 'Active',
  },
  {
    id: '3',
    name: 'Gazipur Sadar Sub-Registry Office',
    districtId: '2',
    status: 'Active',
  },
  {
    id: '4',
    name: 'Rupganj Sub-Registry Office',
    districtId: '3',
    status: 'Active',
  },
  {
    id: '5',
    name: 'Chittagong Sadar Sub-Registry Office',
    districtId: '4',
    status: 'Active',
  },
  {
    id: '6',
    name: 'Rajshahi Sadar Sub-Registry Office',
    districtId: '5',
    status: 'Active',
  },
]

// Users
export const users: User[] = [
  {
    id: '1',
    name: 'Md. Kamal Hossain',
    email: 'kamal.hossain@incepta.com',
    role: 'Admin',
    status: 'Active',
    lastLogin: '2026-02-25 09:30 AM',
  },
  {
    id: '2',
    name: 'Fatema Akter',
    email: 'fatema.akter@incepta.com',
    role: 'Legal Officer',
    status: 'Active',
    lastLogin: '2026-02-25 10:15 AM',
  },
  {
    id: '3',
    name: 'Md. Rahim Uddin',
    email: 'rahim.uddin@incepta.com',
    role: 'Legal Officer',
    status: 'Active',
    lastLogin: '2026-02-24 04:45 PM',
  },
  {
    id: '4',
    name: 'Nasreen Sultana',
    email: 'nasreen.sultana@incepta.com',
    role: 'Viewer',
    status: 'Active',
    lastLogin: '2026-02-25 08:00 AM',
  },
  {
    id: '5',
    name: 'Abdul Mannan',
    email: 'abdul.mannan@incepta.com',
    role: 'Viewer',
    status: 'Inactive',
    lastLogin: '2026-01-15 02:30 PM',
  },
]

// Land Records - 12 records with realistic Bangladesh data
export const landRecords: LandRecord[] = [
  // Record 1: PRIMARY DEMO - Factory Expansion
  {
    id: '1',
    landId: 'LR-2026-001',
    landName: 'Factory Expansion – Dhamrai',
    status: 'Active',
    verification: 'Verified',
    deedNo: 'DR-2026-01457',
    deedType: 'Sale Deed',
    executionDate: '2025-08-15',
    registrationDate: '2025-09-02',
    subRegistry: 'Dhamrai Sub-Registry Office',
    mouza: 'Sutipara',
    union: 'Sutipara Union',
    upazila: 'Dhamrai',
    district: 'Dhaka',
    areaDecimal: 150,
    areaKatha: 6.07,
    areaAcre: 2.27,
    landType: 'Industrial',
    sapRef: 'SAP-2026-FA-001',
    actualValue: 45000000,
    deedValue: 38000000,
    mouzaValue: 35000000,
    registrationCosts: {
      stampDuty: 2280000,
      registrationFee: 380000,
      localGovtTax: 114000,
      eStamp: 500,
      miscellaneous: 15000,
      total: 2789500,
    },
    transferors: [
      {
        name: 'Md. Rafiqul Islam',
        nid: '1990123456789',
        address: 'Sutipara, Dhamrai, Dhaka',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
        representative: 'Md. Kamal Hossain (Director)',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [
      {
        id: '1',
        deedNo: 'DR-2001-05234',
        deedType: 'Inheritance',
        registrationDate: '2001-03-15',
        transferor: 'Late Haji Abdul Karim',
        transferee: 'Md. Shamsul Haque',
        history: 'Original inheritance from father',
      },
      {
        id: '2',
        deedNo: 'DR-2006-08912',
        deedType: 'Sale Deed',
        registrationDate: '2006-07-22',
        transferor: 'Md. Shamsul Haque',
        transferee: 'Md. Nurul Islam',
        history: 'Purchased for agricultural use',
      },
      {
        id: '3',
        deedNo: 'DR-2012-03456',
        deedType: 'Gift Deed',
        registrationDate: '2012-01-10',
        transferor: 'Md. Nurul Islam',
        transferee: 'Md. Rafiqul Islam (Son)',
        history: 'Gift to son',
      },
      {
        id: '4',
        deedNo: 'DR-2015-07890',
        deedType: 'Partition Deed',
        registrationDate: '2015-05-18',
        transferor: 'Md. Rafiqul Islam & Brothers',
        transferee: 'Md. Rafiqul Islam',
        history: 'Family partition - sole ownership',
      },
      {
        id: '5',
        deedNo: 'DR-2020-02345',
        deedType: 'Correction Deed',
        registrationDate: '2020-09-05',
        transferor: 'Md. Rafiqul Islam',
        transferee: 'Md. Rafiqul Islam',
        history: 'Boundary correction',
      },
      {
        id: '6',
        deedNo: 'DR-2026-01457',
        deedType: 'Sale Deed',
        registrationDate: '2025-09-02',
        transferor: 'Md. Rafiqul Islam',
        transferee: 'Incepta Pharmaceuticals Ltd.',
        history: 'Current purchase for factory expansion',
      },
    ],
    ownershipChainComplete: true,
    scheduleOfLand: {
      cs: {
        khatianNo: '245',
        totalLand: '150 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '112',
            sharedLand: '80 Decimal',
            transferredLand: '50 Decimal',
          },
          {
            id: '2',
            dagNo: '113',
            sharedLand: '150 Decimal',
            transferredLand: '100 Decimal',
          },
        ],
      },
      sa: {
        khatianNo: '302',
        totalLand: '150 Decimal',
        dags: [
          {
            id: '3',
            dagNo: '78',
            sharedLand: '80 Decimal',
            transferredLand: '50 Decimal',
          },
          {
            id: '4',
            dagNo: '79',
            sharedLand: '150 Decimal',
            transferredLand: '100 Decimal',
          },
        ],
      },
      rs: {
        khatianNo: '456',
        totalLand: '150 Decimal',
        dags: [
          {
            id: '5',
            dagNo: '201',
            sharedLand: '100 Decimal',
            transferredLand: '75 Decimal',
          },
          {
            id: '6',
            dagNo: '202',
            sharedLand: '100 Decimal',
            transferredLand: '75 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: "Md. Rahim Mia's land",
      south: 'Public Road (Dhamrai-Tangail Highway)',
      east: 'Khal (Canal)',
      west: "Md. Jamal Uddin's land",
    },
    location: {
      lat: 23.9103,
      lng: 90.3535,
      label: 'Factory Site – Sutipara, Dhamrai',
    },
    mutation: {
      caseNo: 'MUT-2026-0234',
      filingDate: '2025-10-01',
      joteNo: 'J-45',
      mutationKhatianNo: 'Pending',
      totalLand: '150 Decimal',
      fileNo: 'F-2026-0234',
      status: 'Pending',
      followUpDue: '2026-03-07',
    },
    khajna: {
      receiptNo: 'KHJ-2025-5678',
      caseNo: 'KC-2026-0112',
      submissionDate: '2025-04-15',
      upToDate: false,
      dueDate: '2026-02-28',
      totalLand: '150 Decimal',
      fileNo: 'F-2026-0112',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [
      {
        id: 'd1',
        title: 'Sale Deed – DR-2026-01457',
        type: 'Deed',
        date: '2025-09-02',
        tags: ['original', 'registered'],
        linkedRecordId: '1',
      },
      {
        id: 'd2',
        title: 'Mutation Filing Receipt',
        type: 'Mutation',
        date: '2025-10-01',
        tags: ['pending'],
        linkedRecordId: '1',
      },
      {
        id: 'd3',
        title: 'Previous Khajna Receipt 2024-25',
        type: 'Khajna',
        date: '2025-04-15',
        tags: ['paid'],
        linkedRecordId: '1',
      },
    ],
    activityLog: [
      {
        id: 'a1',
        action: 'Record Created',
        user: 'Md. Kamal Hossain',
        timestamp: '2025-09-05 10:30 AM',
        details: 'Initial land record created',
      },
      {
        id: 'a2',
        action: 'Deed Uploaded',
        user: 'Fatema Akter',
        timestamp: '2025-09-05 11:15 AM',
        details: 'Sale deed document uploaded',
      },
      {
        id: 'a3',
        action: 'Mutation Filed',
        user: 'Fatema Akter',
        timestamp: '2025-10-01 02:30 PM',
        details: 'Mutation case filed at AC Land Office',
      },
      {
        id: 'a4',
        action: 'Verification Completed',
        user: 'Md. Kamal Hossain',
        timestamp: '2025-10-15 04:00 PM',
        details: 'All documents verified and approved',
      },
      {
        id: 'a5',
        action: 'Record Updated',
        user: 'Fatema Akter',
        timestamp: '2026-02-20 09:45 AM',
        details: 'Khajna due date updated',
      },
    ],
    createdBy: 'Md. Kamal Hossain',
    createdDate: '2025-09-05',
    lastUpdatedBy: 'Fatema Akter',
    lastUpdatedDate: '2026-02-20',
  },

  // Record 2: LITIGATION DEMO - Warehouse Land
  {
    id: '2',
    landId: 'LR-2025-002',
    landName: 'Warehouse Land – Gazipur',
    status: 'Active',
    verification: 'Verified',
    deedNo: 'GZ-2024-08932',
    deedType: 'Sale Deed',
    executionDate: '2024-03-10',
    registrationDate: '2024-03-25',
    subRegistry: 'Gazipur Sadar Sub-Registry Office',
    mouza: 'Basan',
    union: 'Basan Union',
    upazila: 'Gazipur Sadar',
    district: 'Gazipur',
    areaDecimal: 200,
    areaKatha: 8.09,
    areaAcre: 3.03,
    landType: 'Warehouse',
    sapRef: 'SAP-2024-WH-002',
    actualValue: 60000000,
    deedValue: 52000000,
    mouzaValue: 48000000,
    registrationCosts: {
      stampDuty: 3120000,
      registrationFee: 520000,
      localGovtTax: 156000,
      eStamp: 500,
      total: 3796500,
    },
    transferors: [
      {
        name: 'Md. Shahidul Islam',
        nid: '1985234567890',
        address: 'Basan, Gazipur Sadar, Gazipur',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
        representative: 'Md. Rahim Uddin (Manager)',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [
      {
        id: '1',
        deedNo: 'GZ-1998-02345',
        deedType: 'Sale Deed',
        registrationDate: '1998-06-12',
        transferor: 'Md. Abdul Aziz',
        transferee: 'Md. Karim Mia',
        history: 'Original purchase',
      },
      {
        id: '2',
        deedNo: 'GZ-2005-04567',
        deedType: 'Inheritance',
        registrationDate: '2005-02-20',
        transferor: 'Late Md. Karim Mia',
        transferee: 'Md. Shahidul Islam',
        history: 'Inherited from father',
      },
      {
        id: '3',
        deedNo: 'GZ-2024-08932',
        deedType: 'Sale Deed',
        registrationDate: '2024-03-25',
        transferor: 'Md. Shahidul Islam',
        transferee: 'Incepta Pharmaceuticals Ltd.',
        history: 'Current purchase',
      },
    ],
    ownershipChainComplete: true,
    scheduleOfLand: {
      cs: {
        khatianNo: '567',
        totalLand: '200 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '234',
            sharedLand: '200 Decimal',
            transferredLand: '200 Decimal',
          },
        ],
      },
      rs: {
        khatianNo: '789',
        totalLand: '200 Decimal',
        dags: [
          {
            id: '2',
            dagNo: '345',
            sharedLand: '200 Decimal',
            transferredLand: '200 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'BSCIC Industrial Area',
      south: 'Dhaka-Mymensingh Highway',
      east: "Md. Hanif's land",
      west: 'Government Khas Land',
    },
    location: {
      lat: 24.0023,
      lng: 90.4193,
      label: 'Warehouse Site – Basan, Gazipur',
    },
    mutation: {
      caseNo: 'MUT-2024-0567',
      filingDate: '2024-04-10',
      joteNo: 'J-78',
      mutationKhatianNo: 'MK-2024-0567',
      totalLand: '200 Decimal',
      fileNo: 'F-2024-0567',
      status: 'Approved',
    },
    khajna: {
      receiptNo: 'KHJ-2025-1234',
      caseNo: 'KC-2025-0089',
      submissionDate: '2025-06-30',
      upToDate: true,
      dueDate: '2026-06-30',
      totalLand: '200 Decimal',
      fileNo: 'F-2025-0089',
    },
    subsequentTransfer: { enabled: false },
    litigation: [
      {
        id: 'lit1',
        caseNo: 'CS-2025-1234',
        type: 'Land Boundary Dispute',
        plaintiff: 'Md. Hanif Mia',
        defendant: 'Incepta Pharmaceuticals Ltd.',
        court: 'District Judge Court, Gazipur',
        status: 'Ongoing',
      },
    ],
    documents: [
      {
        id: 'd4',
        title: 'Sale Deed – GZ-2024-08932',
        type: 'Deed',
        date: '2024-03-25',
        tags: ['original', 'registered'],
        linkedRecordId: '2',
      },
      {
        id: 'd5',
        title: 'Mutation Certificate',
        type: 'Mutation',
        date: '2024-08-15',
        tags: ['approved'],
        linkedRecordId: '2',
      },
      {
        id: 'd6',
        title: 'Litigation Notice',
        type: 'Litigation',
        date: '2025-01-20',
        tags: ['court', 'pending'],
        linkedRecordId: '2',
      },
    ],
    activityLog: [
      {
        id: 'a6',
        action: 'Record Created',
        user: 'Md. Rahim Uddin',
        timestamp: '2024-03-28 09:00 AM',
        details: 'Initial record created',
      },
      {
        id: 'a7',
        action: 'Litigation Added',
        user: 'Fatema Akter',
        timestamp: '2025-01-22 03:30 PM',
        details: 'Boundary dispute case added',
      },
    ],
    createdBy: 'Md. Rahim Uddin',
    createdDate: '2024-03-28',
    lastUpdatedBy: 'Fatema Akter',
    lastUpdatedDate: '2025-01-22',
  },

  // Record 3: VIEWER/LEGACY DEMO - Legacy Land
  {
    id: '3',
    landId: 'LR-2020-003',
    landName: 'Legacy Land – Narayanganj',
    status: 'Active',
    verification: 'Pending',
    deedNo: 'NR-2020-04567',
    deedType: 'Sale Deed',
    executionDate: '2020-05-15',
    registrationDate: '2020-06-01',
    subRegistry: 'Rupganj Sub-Registry Office',
    mouza: 'Murapara',
    union: 'Murapara Union',
    upazila: 'Rupganj',
    district: 'Narayanganj',
    areaDecimal: 100,
    areaKatha: 4.05,
    areaAcre: 1.52,
    landType: 'Industrial',
    actualValue: 30000000,
    deedValue: 25000000,
    mouzaValue: 22000000,
    registrationCosts: {
      stampDuty: 1500000,
      registrationFee: 250000,
      localGovtTax: 75000,
      eStamp: 500,
      total: 1825500,
    },
    transferors: [
      {
        name: 'Md. Jamal Hossain',
        nid: '1975345678901',
        address: 'Murapara, Rupganj, Narayanganj',
      },
      {
        name: 'Mst. Rahima Begum',
        nid: '1978456789012',
        address: 'Murapara, Rupganj, Narayanganj',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
        representative: 'Md. Kamal Hossain (Director)',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [
      {
        id: '1',
        deedNo: 'NR-2010-01234',
        deedType: 'Sale Deed',
        registrationDate: '2010-08-20',
        transferor: 'Md. Akbar Ali',
        transferee: 'Md. Jamal Hossain',
        history: 'Purchase from original owner',
      },
      {
        id: '2',
        deedNo: 'NR-2015-02345',
        deedType: 'Gift Deed',
        registrationDate: '2015-03-10',
        transferor: 'Md. Jamal Hossain',
        transferee: 'Md. Jamal Hossain & Mst. Rahima Begum',
        history: 'Joint ownership with wife',
      },
      {
        id: '3',
        deedNo: 'NR-2020-04567',
        deedType: 'Sale Deed',
        registrationDate: '2020-06-01',
        transferor: 'Md. Jamal Hossain & Mst. Rahima Begum',
        transferee: 'Incepta Pharmaceuticals Ltd.',
        history: 'Current purchase',
      },
    ],
    ownershipChainComplete: false, // Only 15 years - incomplete
    scheduleOfLand: {
      cs: {
        khatianNo: '123',
        totalLand: '100 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '456',
            sharedLand: '150 Decimal',
            transferredLand: '50 Decimal',
          },
          {
            id: '2',
            dagNo: '457',
            sharedLand: '100 Decimal',
            transferredLand: '50 Decimal',
          },
        ],
      },
      sa: {
        khatianNo: '234',
        totalLand: '100 Decimal',
        dags: [
          {
            id: '3',
            dagNo: '567',
            sharedLand: '150 Decimal',
            transferredLand: '50 Decimal',
          },
          {
            id: '4',
            dagNo: '568',
            sharedLand: '100 Decimal',
            transferredLand: '50 Decimal',
          },
        ],
      },
      rs: {
        khatianNo: '345',
        totalLand: '100 Decimal',
        dags: [
          {
            id: '5',
            dagNo: '678',
            sharedLand: '100 Decimal',
            transferredLand: '50 Decimal',
          },
          {
            id: '6',
            dagNo: '679',
            sharedLand: '100 Decimal',
            transferredLand: '50 Decimal',
          },
        ],
      },
      bds: {
        khatianNo: '456',
        totalLand: '100 Decimal',
        dags: [
          {
            id: '7',
            dagNo: '789',
            sharedLand: '100 Decimal',
            transferredLand: '50 Decimal',
          },
          {
            id: '8',
            dagNo: '790',
            sharedLand: '100 Decimal',
            transferredLand: '50 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Shitalakshya River',
      south: 'Dhaka-Chittagong Highway',
      east: "Md. Salam's land",
      west: 'Government Canal',
    },
    location: {
      lat: 23.7461,
      lng: 90.5178,
      label: 'Legacy Site – Murapara, Narayanganj',
    },
    khajna: {
      receiptNo: 'KHJ-2025-3456',
      caseNo: 'KC-2025-0234',
      submissionDate: '2025-05-15',
      upToDate: true,
      dueDate: '2026-05-15',
      totalLand: '100 Decimal',
      fileNo: 'F-2025-0234',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [
      {
        id: 'd7',
        title: 'Sale Deed – NR-2020-04567',
        type: 'Deed',
        date: '2020-06-01',
        tags: ['original'],
        linkedRecordId: '3',
      },
    ],
    activityLog: [
      {
        id: 'a8',
        action: 'Record Created',
        user: 'Md. Kamal Hossain',
        timestamp: '2020-06-05 10:00 AM',
        details: 'Legacy record migrated',
      },
    ],
    createdBy: 'Md. Kamal Hossain',
    createdDate: '2020-06-05',
    lastUpdatedBy: 'Md. Kamal Hossain',
    lastUpdatedDate: '2020-06-05',
  },

  // Records 4-12: Mixed states and districts
  {
    id: '4',
    landId: 'LR-2024-004',
    landName: 'Distribution Center – Chittagong',
    status: 'Active',
    verification: 'Verified',
    deedNo: 'CT-2024-12345',
    deedType: 'Sale Deed',
    executionDate: '2024-01-15',
    registrationDate: '2024-02-01',
    subRegistry: 'Chittagong Sadar Sub-Registry Office',
    mouza: 'Patenga',
    union: 'Patenga Ward',
    upazila: 'Chittagong Sadar',
    district: 'Chittagong',
    areaDecimal: 300,
    areaKatha: 12.14,
    areaAcre: 4.55,
    landType: 'Commercial',
    actualValue: 90000000,
    deedValue: 80000000,
    mouzaValue: 75000000,
    registrationCosts: {
      stampDuty: 4800000,
      registrationFee: 800000,
      localGovtTax: 240000,
      eStamp: 500,
      total: 5840500,
    },
    transferors: [
      {
        name: 'Chittagong Properties Ltd.',
        nid: 'TIN: 987654321098',
        address: 'Agrabad, Chittagong',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
        representative: 'Md. Kamal Hossain',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [
      {
        id: '1',
        deedNo: 'CT-2000-05678',
        deedType: 'Sale Deed',
        registrationDate: '2000-05-10',
        transferor: 'Government',
        transferee: 'Chittagong Properties Ltd.',
        history: 'Original allocation',
      },
      {
        id: '2',
        deedNo: 'CT-2024-12345',
        deedType: 'Sale Deed',
        registrationDate: '2024-02-01',
        transferor: 'Chittagong Properties Ltd.',
        transferee: 'Incepta Pharmaceuticals Ltd.',
        history: 'Current purchase',
      },
    ],
    ownershipChainComplete: true,
    scheduleOfLand: {
      rs: {
        khatianNo: '890',
        totalLand: '300 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '901',
            sharedLand: '300 Decimal',
            transferredLand: '300 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Bay of Bengal',
      south: 'Port Access Road',
      east: 'CPA Land',
      west: 'Private Land',
    },
    location: {
      lat: 22.2352,
      lng: 91.8123,
      label: 'Distribution Center – Patenga, Chittagong',
    },
    khajna: {
      receiptNo: 'KHJ-2025-7890',
      caseNo: 'KC-2025-0456',
      submissionDate: '2025-03-01',
      upToDate: true,
      dueDate: '2026-03-01',
      totalLand: '300 Decimal',
      fileNo: 'F-2025-0456',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [
      {
        id: 'd8',
        title: 'Sale Deed – CT-2024-12345',
        type: 'Deed',
        date: '2024-02-01',
        tags: ['original'],
        linkedRecordId: '4',
      },
    ],
    activityLog: [
      {
        id: 'a9',
        action: 'Record Created',
        user: 'Fatema Akter',
        timestamp: '2024-02-05 11:00 AM',
        details: 'New record created',
      },
    ],
    createdBy: 'Fatema Akter',
    createdDate: '2024-02-05',
    lastUpdatedBy: 'Fatema Akter',
    lastUpdatedDate: '2024-02-05',
  },

  {
    id: '5',
    landId: 'LR-2023-005',
    landName: 'Research Facility Land – Rajshahi',
    status: 'Inactive',
    verification: 'Verified',
    deedNo: 'RJ-2023-06789',
    deedType: 'Sale Deed',
    executionDate: '2023-06-20',
    registrationDate: '2023-07-05',
    subRegistry: 'Rajshahi Sadar Sub-Registry Office',
    mouza: 'Kazla',
    union: 'Kazla Union',
    upazila: 'Rajshahi Sadar',
    district: 'Rajshahi',
    areaDecimal: 80,
    areaKatha: 3.24,
    areaAcre: 1.21,
    landType: 'Industrial',
    actualValue: 20000000,
    deedValue: 18000000,
    mouzaValue: 16000000,
    registrationCosts: {
      stampDuty: 1080000,
      registrationFee: 180000,
      localGovtTax: 54000,
      eStamp: 500,
      total: 1314500,
    },
    transferors: [
      {
        name: 'Md. Habibur Rahman',
        nid: '1970567890123',
        address: 'Kazla, Rajshahi',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [
      {
        id: '1',
        deedNo: 'RJ-2023-06789',
        deedType: 'Sale Deed',
        registrationDate: '2023-07-05',
        transferor: 'Md. Habibur Rahman',
        transferee: 'Incepta Pharmaceuticals Ltd.',
        history: 'Direct purchase',
      },
    ],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '234',
        totalLand: '80 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '345',
            sharedLand: '80 Decimal',
            transferredLand: '80 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Agricultural Land',
      south: 'Village Road',
      east: 'Pond',
      west: 'School Ground',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [
      {
        id: 'd9',
        title: 'Sale Deed – RJ-2023-06789',
        type: 'Deed',
        date: '2023-07-05',
        tags: ['original'],
        linkedRecordId: '5',
      },
    ],
    activityLog: [
      {
        id: 'a10',
        action: 'Record Created',
        user: 'Md. Rahim Uddin',
        timestamp: '2023-07-10 09:30 AM',
        details: 'New record',
      },
    ],
    createdBy: 'Md. Rahim Uddin',
    createdDate: '2023-07-10',
    lastUpdatedBy: 'Md. Rahim Uddin',
    lastUpdatedDate: '2023-07-10',
  },

  {
    id: '6',
    landId: 'LR-2024-006',
    landName: 'Storage Facility – Sylhet',
    status: 'Active',
    verification: 'Pending',
    deedNo: 'SL-2024-03456',
    deedType: 'Sale Deed',
    executionDate: '2024-08-10',
    registrationDate: '2024-08-25',
    subRegistry: 'Sylhet Sadar Sub-Registry Office',
    mouza: 'Khadimpara',
    union: 'Khadimpara Union',
    upazila: 'Sylhet Sadar',
    district: 'Sylhet',
    areaDecimal: 120,
    areaKatha: 4.86,
    areaAcre: 1.82,
    landType: 'Warehouse',
    actualValue: 35000000,
    deedValue: 30000000,
    mouzaValue: 28000000,
    registrationCosts: {
      stampDuty: 1800000,
      registrationFee: 300000,
      localGovtTax: 90000,
      eStamp: 500,
      total: 2190500,
    },
    transferors: [
      {
        name: 'Sylhet Land Holdings',
        nid: 'TIN: 456789012345',
        address: 'Zindabazar, Sylhet',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '567',
        totalLand: '120 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '678',
            sharedLand: '120 Decimal',
            transferredLand: '120 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Tea Garden',
      south: 'Sylhet-Sunamganj Road',
      east: 'River',
      west: 'Private Land',
    },
    khajna: {
      receiptNo: 'KHJ-2025-4567',
      caseNo: 'KC-2025-0567',
      submissionDate: '2025-01-15',
      upToDate: false,
      dueDate: '2026-03-15',
      totalLand: '120 Decimal',
      fileNo: 'F-2025-0567',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [],
    activityLog: [],
    createdBy: 'Fatema Akter',
    createdDate: '2024-08-28',
    lastUpdatedBy: 'Fatema Akter',
    lastUpdatedDate: '2024-08-28',
  },

  {
    id: '7',
    landId: 'LR-2022-007',
    landName: 'Packaging Unit – Comilla',
    status: 'Active',
    verification: 'Verified',
    deedNo: 'CM-2022-07890',
    deedType: 'Sale Deed',
    executionDate: '2022-11-05',
    registrationDate: '2022-11-20',
    subRegistry: 'Comilla Sadar Sub-Registry Office',
    mouza: 'Kotbari',
    union: 'Kotbari Union',
    upazila: 'Comilla Sadar',
    district: 'Comilla',
    areaDecimal: 90,
    areaKatha: 3.64,
    areaAcre: 1.36,
    landType: 'Industrial',
    actualValue: 25000000,
    deedValue: 22000000,
    mouzaValue: 20000000,
    registrationCosts: {
      stampDuty: 1320000,
      registrationFee: 220000,
      localGovtTax: 66000,
      eStamp: 500,
      total: 1606500,
    },
    transferors: [
      {
        name: 'Md. Anwar Hossain',
        nid: '1968678901234',
        address: 'Kotbari, Comilla',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '789',
        totalLand: '90 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '890',
            sharedLand: '90 Decimal',
            transferredLand: '90 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'BSCIC Area',
      south: 'Comilla-Dhaka Highway',
      east: 'Canal',
      west: 'Private Land',
    },
    location: {
      lat: 23.4607,
      lng: 91.1809,
      label: 'Packaging Unit – Kotbari, Comilla',
    },
    khajna: {
      receiptNo: 'KHJ-2025-5678',
      caseNo: 'KC-2025-0678',
      submissionDate: '2025-02-01',
      upToDate: true,
      dueDate: '2026-02-01',
      totalLand: '90 Decimal',
      fileNo: 'F-2025-0678',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [],
    activityLog: [],
    createdBy: 'Md. Rahim Uddin',
    createdDate: '2022-11-25',
    lastUpdatedBy: 'Md. Rahim Uddin',
    lastUpdatedDate: '2022-11-25',
  },

  {
    id: '8',
    landId: 'LR-2021-008',
    landName: 'Regional Office – Rangpur',
    status: 'Inactive',
    verification: 'Rejected',
    deedNo: 'RP-2021-04567',
    deedType: 'Sale Deed',
    executionDate: '2021-04-15',
    registrationDate: '2021-05-01',
    subRegistry: 'Rangpur Sadar Sub-Registry Office',
    mouza: 'Mahiganj',
    union: 'Mahiganj Union',
    upazila: 'Rangpur Sadar',
    district: 'Rangpur',
    areaDecimal: 50,
    areaKatha: 2.02,
    areaAcre: 0.76,
    landType: 'Commercial',
    actualValue: 12000000,
    deedValue: 10000000,
    mouzaValue: 9000000,
    registrationCosts: {
      stampDuty: 600000,
      registrationFee: 100000,
      localGovtTax: 30000,
      eStamp: 500,
      total: 730500,
    },
    transferors: [
      {
        name: 'Rangpur Developers',
        nid: 'TIN: 567890123456',
        address: 'Rangpur City',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '901',
        totalLand: '50 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '012',
            sharedLand: '50 Decimal',
            transferredLand: '50 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Main Road',
      south: 'Residential Area',
      east: 'Market',
      west: 'School',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [],
    activityLog: [],
    createdBy: 'Md. Kamal Hossain',
    createdDate: '2021-05-05',
    lastUpdatedBy: 'Md. Kamal Hossain',
    lastUpdatedDate: '2021-05-05',
  },

  {
    id: '9',
    landId: 'LR-2025-009',
    landName: 'Cold Storage – Khulna',
    status: 'Active',
    verification: 'Verified',
    deedNo: 'KH-2025-01234',
    deedType: 'Sale Deed',
    executionDate: '2025-01-10',
    registrationDate: '2025-01-25',
    subRegistry: 'Khulna Sadar Sub-Registry Office',
    mouza: 'Daulatpur',
    union: 'Daulatpur Ward',
    upazila: 'Khulna Sadar',
    district: 'Khulna',
    areaDecimal: 180,
    areaKatha: 7.29,
    areaAcre: 2.73,
    landType: 'Warehouse',
    actualValue: 50000000,
    deedValue: 45000000,
    mouzaValue: 42000000,
    registrationCosts: {
      stampDuty: 2700000,
      registrationFee: 450000,
      localGovtTax: 135000,
      eStamp: 500,
      total: 3285500,
    },
    transferors: [
      {
        name: 'Khulna Industrial Corp.',
        nid: 'TIN: 678901234567',
        address: 'Khulna City',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '012',
        totalLand: '180 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '123',
            sharedLand: '180 Decimal',
            transferredLand: '180 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Rupsha River',
      south: 'Industrial Zone',
      east: 'Highway',
      west: 'Private Land',
    },
    location: {
      lat: 22.8456,
      lng: 89.5403,
      label: 'Cold Storage – Daulatpur, Khulna',
    },
    khajna: {
      receiptNo: 'KHJ-2025-6789',
      caseNo: 'KC-2025-0789',
      submissionDate: '2025-02-15',
      upToDate: true,
      dueDate: '2026-02-15',
      totalLand: '180 Decimal',
      fileNo: 'F-2025-0789',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [],
    activityLog: [],
    createdBy: 'Fatema Akter',
    createdDate: '2025-01-28',
    lastUpdatedBy: 'Fatema Akter',
    lastUpdatedDate: '2025-01-28',
  },

  {
    id: '10',
    landId: 'LR-2023-010',
    landName: 'API Plant Land – Mymensingh',
    status: 'Active',
    verification: 'Pending',
    deedNo: 'MY-2023-08901',
    deedType: 'Sale Deed',
    executionDate: '2023-09-05',
    registrationDate: '2023-09-20',
    subRegistry: 'Mymensingh Sadar Sub-Registry Office',
    mouza: 'Shambhuganj',
    union: 'Shambhuganj Union',
    upazila: 'Mymensingh Sadar',
    district: 'Mymensingh',
    areaDecimal: 250,
    areaKatha: 10.12,
    areaAcre: 3.79,
    landType: 'Industrial',
    actualValue: 70000000,
    deedValue: 62000000,
    mouzaValue: 58000000,
    registrationCosts: {
      stampDuty: 3720000,
      registrationFee: 620000,
      localGovtTax: 186000,
      eStamp: 500,
      total: 4526500,
    },
    transferors: [
      {
        name: 'Mymensingh Agro Ltd.',
        nid: 'TIN: 789012345678',
        address: 'Mymensingh City',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '234',
        totalLand: '250 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '345',
            sharedLand: '250 Decimal',
            transferredLand: '250 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Brahmaputra River',
      south: 'Agricultural Land',
      east: 'Village Road',
      west: 'Forest',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [],
    activityLog: [],
    createdBy: 'Md. Rahim Uddin',
    createdDate: '2023-09-25',
    lastUpdatedBy: 'Md. Rahim Uddin',
    lastUpdatedDate: '2023-09-25',
  },

  {
    id: '11',
    landId: 'LR-2022-011',
    landName: 'Depot Land – Bogra',
    status: 'Active',
    verification: 'Verified',
    deedNo: 'BG-2022-05678',
    deedType: 'Sale Deed',
    executionDate: '2022-06-15',
    registrationDate: '2022-07-01',
    subRegistry: 'Bogra Sadar Sub-Registry Office',
    mouza: 'Sherpur',
    union: 'Sherpur Union',
    upazila: 'Bogra Sadar',
    district: 'Bogra',
    areaDecimal: 70,
    areaKatha: 2.83,
    areaAcre: 1.06,
    landType: 'Commercial',
    actualValue: 18000000,
    deedValue: 15000000,
    mouzaValue: 14000000,
    registrationCosts: {
      stampDuty: 900000,
      registrationFee: 150000,
      localGovtTax: 45000,
      eStamp: 500,
      total: 1095500,
    },
    transferors: [
      {
        name: 'Md. Fazlur Rahman',
        nid: '1965789012345',
        address: 'Sherpur, Bogra',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '456',
        totalLand: '70 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '567',
            sharedLand: '70 Decimal',
            transferredLand: '70 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Market Area',
      south: 'Residential',
      east: 'Main Road',
      west: 'Agricultural Land',
    },
    location: { lat: 24.8465, lng: 89.3773, label: 'Depot – Sherpur, Bogra' },
    khajna: {
      receiptNo: 'KHJ-2025-7890',
      caseNo: 'KC-2025-0890',
      submissionDate: '2025-01-01',
      upToDate: true,
      dueDate: '2026-01-01',
      totalLand: '70 Decimal',
      fileNo: 'F-2025-0890',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [],
    activityLog: [],
    createdBy: 'Md. Kamal Hossain',
    createdDate: '2022-07-05',
    lastUpdatedBy: 'Md. Kamal Hossain',
    lastUpdatedDate: '2022-07-05',
  },

  {
    id: '12',
    landId: 'LR-2024-012',
    landName: 'Distribution Hub – Jessore',
    status: 'Inactive',
    verification: 'Pending',
    deedNo: 'JS-2024-02345',
    deedType: 'Gift Deed',
    executionDate: '2024-05-20',
    registrationDate: '2024-06-05',
    subRegistry: 'Jessore Sadar Sub-Registry Office',
    mouza: 'Chanchra',
    union: 'Chanchra Union',
    upazila: 'Jessore Sadar',
    district: 'Jessore',
    areaDecimal: 110,
    areaKatha: 4.45,
    areaAcre: 1.67,
    landType: 'Commercial',
    actualValue: 28000000,
    deedValue: 25000000,
    mouzaValue: 23000000,
    registrationCosts: {
      stampDuty: 1500000,
      registrationFee: 250000,
      localGovtTax: 75000,
      eStamp: 500,
      total: 1825500,
    },
    transferors: [
      {
        name: 'Jessore Holdings Ltd.',
        nid: 'TIN: 890123456789',
        address: 'Jessore City',
      },
    ],
    transferees: [
      {
        name: 'Incepta Pharmaceuticals Ltd.',
        nid: 'TIN: 123456789012',
        address: 'Zirabo, Ashulia, Dhaka',
      },
    ],
    poa: { enabled: false },
    ownershipChain: [],
    ownershipChainComplete: false,
    scheduleOfLand: {
      rs: {
        khatianNo: '678',
        totalLand: '110 Decimal',
        dags: [
          {
            id: '1',
            dagNo: '789',
            sharedLand: '110 Decimal',
            transferredLand: '110 Decimal',
          },
        ],
      },
    },
    periphery: {
      north: 'Highway',
      south: 'Agricultural Land',
      east: 'Canal',
      west: 'Village',
    },
    subsequentTransfer: { enabled: false },
    litigation: [],
    documents: [],
    activityLog: [],
    createdBy: 'Fatema Akter',
    createdDate: '2024-06-10',
    lastUpdatedBy: 'Fatema Akter',
    lastUpdatedDate: '2024-06-10',
  },
]

// Notifications
export const notifications: Notification[] = [
  {
    id: 'n1',
    type: 'khajna-due',
    landId: 'LR-2026-001',
    landName: 'Factory Expansion – Dhamrai',
    message: 'Khajna payment due in 3 days',
    dueDate: '2026-02-28',
    urgency: 'high',
    read: false,
    createdAt: '2026-02-25 08:00 AM',
  },
  {
    id: 'n2',
    type: 'mutation-followup',
    landId: 'LR-2026-001',
    landName: 'Factory Expansion – Dhamrai',
    message: 'Mutation follow-up due in 10 days',
    dueDate: '2026-03-07',
    urgency: 'medium',
    read: false,
    createdAt: '2026-02-25 08:00 AM',
  },
  {
    id: 'n3',
    type: 'khajna-due',
    landId: 'LR-2024-006',
    landName: 'Storage Facility – Sylhet',
    message: 'Khajna payment due in 18 days',
    dueDate: '2026-03-15',
    urgency: 'medium',
    read: true,
    createdAt: '2026-02-24 09:00 AM',
  },
  {
    id: 'n4',
    type: 'verification-changed',
    landId: 'LR-2026-001',
    landName: 'Factory Expansion – Dhamrai',
    message: 'Verification status changed to Verified',
    urgency: 'low',
    read: true,
    createdAt: '2025-10-15 04:00 PM',
  },
]

// All documents (aggregated from land records + standalone)
export const allDocuments: Document[] = [
  ...landRecords.flatMap((r) => r.documents),
  {
    id: 'd10',
    title: 'Company Registration Certificate',
    type: 'Other',
    date: '2020-01-15',
    tags: ['company', 'legal'],
    fileName: 'company_reg.pdf',
  },
  {
    id: 'd11',
    title: 'Board Resolution for Land Purchase',
    type: 'Other',
    date: '2025-08-01',
    tags: ['board', 'approval'],
    fileName: 'board_resolution.pdf',
  },
]
